<template>
  <div
    class="card Netpa-Shadow bnp-rounded netpa-card m-1 ml-1 mt-2 h-100"
    :class="variantModifier"
    dir="rtl"
  >
    <div class="card-header netpa-card__header position-relative">
      <div class="netpa-card__title">
        <slot name="header"></slot>
      </div>
      <button
        v-if="IsMinus"
        type="button"
        class="netpa-card__toggle"
        data-toggle="collapse"
        :data-target="IdElement ? '#collapseExample' + IdElement : null"
        :aria-expanded="!IconDown"
        :aria-controls="IdElement ? 'collapseExample' + IdElement : null"
        :aria-label="IconDown ? 'باز کردن بخش' : 'بستن بخش'"
        @click="IconDown = !IconDown"
      >
        <i
          aria-hidden="true"
          :class="IconDown ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"
        ></i>
      </button>
    </div>
    <div
      class="card-body netpa-card__body text-right"
      :class="IsCollapse && IsCollapse == true ? 'collapse ' : 'collapse show'"
      v-if="IsMinus"
      :id="IdElement ? 'collapseExample' + IdElement : ''"
    >
      <slot name="content"></slot>
    </div>
    <div class="card-body netpa-card__body text-right" v-if="!IsMinus">
      <slot name="content"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "NetPaCard",
  data() {
    return {
      IconDown: this.IsCollapse ? true : false,
    };
  },
  computed: {
    variantModifier() {
      const theme = (this.Classes || "").toLowerCase();
      if (!theme) return "";
      if (
        theme.includes("orange") ||
        theme.includes("warning") ||
        theme.includes("yellow")
      ) {
        return "netpa-card--warning";
      }
      if (theme.includes("danger") || theme.includes("red")) {
        return "netpa-card--danger";
      }
      if (
        theme.includes("dark") ||
        theme.includes("success") ||
        theme.includes("green")
      ) {
        return "netpa-card--featured";
      }
      return "";
    },
  },
  props: ["Classes", "IsMinus", "IdElement", "IsCollapse"],
};
</script>
<style scoped>
.netpa-card {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-brand-purple: #8d58a4;
  --bnp-brand-cyan: #05b8c8;
  --bnp-brand-blue: #287db4;
  --bnp-text-primary: #13243a;
  --bnp-text-secondary: #6b7b8e;
  --bnp-surface-card: #ffffff;
  --bnp-surface-accent: #edf7fb;
  --bnp-surface-soft: #f8fafc;
  --bnp-border-default: #dbe5eb;
  --bnp-border-hover: #bdcbd4;
  --bnp-info-soft: #edf5fb;
  --bnp-warning: #c48726;
  --bnp-warning-soft: #fff7e8;
  --bnp-danger: #b44f46;
  --bnp-danger-soft: #fcefed;
  --bnp-radius-lg: 20px;
  --bnp-radius-md: 14px;
  --bnp-shadow-sm: 0 5px 18px rgba(31, 42, 79, 0.08);
  --bnp-shadow-md: 0 12px 24px rgba(41, 52, 95, 0.14);
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);
  --bnp-motion-fast: 180ms;
  --bnp-ease-standard: cubic-bezier(0.165, 0.84, 0.44, 1);

  position: relative;
  min-width: 0;
  overflow: hidden;
  color: var(--bnp-text-primary);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  border: 1px solid var(--bnp-border-default) !important;
  border-radius: var(--bnp-radius-lg) !important;
  background: var(--bnp-surface-card);
  box-shadow: var(--bnp-shadow-sm);
  transition:
    border-color var(--bnp-motion-fast) var(--bnp-ease-standard),
    box-shadow var(--bnp-motion-fast) var(--bnp-ease-standard),
    transform var(--bnp-motion-fast) var(--bnp-ease-standard);
}

/* نوار هویت برند — همیشه ظریف، نه فقط در حالت ویژه */
.netpa-card::before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  width: 3px;
  content: "";
  background: linear-gradient(
    180deg,
    var(--bnp-brand-cyan),
    var(--bnp-brand-indigo) 55%,
    var(--bnp-brand-purple)
  );
  opacity: 0.9;
  pointer-events: none;
}

.netpa-card:hover {
  border-color: rgba(83, 121, 189, 0.28) !important;
  box-shadow: var(--bnp-shadow-md);
  transform: translateY(-1px);
}

.netpa-card--featured {
  border-color: rgba(5, 184, 200, 0.32) !important;
}

.netpa-card--warning {
  border-color: rgba(196, 135, 38, 0.32) !important;
}

.netpa-card--warning::before {
  background: linear-gradient(180deg, #e0a84a, var(--bnp-warning));
}

.netpa-card--danger {
  --bnp-danger: #dc3545;
  --bnp-danger-soft: #f8d7da;
  border-color: rgba(220, 53, 69, 0.35) !important;
}

.netpa-card--danger::before {
  background: linear-gradient(180deg, #e35d6a, #dc3545 55%, #c82333);
}

.bnp-rounded {
  border-radius: var(--bnp-radius-lg);
  overflow: hidden;
}

.netpa-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 62px;
  padding: 14px 18px 14px 16px !important;
  color: var(--bnp-brand-navy);
  border-bottom: 1px solid rgba(219, 229, 235, 0.95) !important;
  background:
    radial-gradient(
      circle at 100% 0%,
      rgba(5, 184, 200, 0.1),
      transparent 42%
    ),
    radial-gradient(
      circle at 0% 100%,
      rgba(141, 88, 164, 0.08),
      transparent 46%
    ),
    linear-gradient(
      100deg,
      rgba(237, 247, 251, 0.96),
      rgba(255, 255, 255, 0.98) 62%
    ) !important;
}

.netpa-card--warning .netpa-card__header {
  background:
    radial-gradient(
      circle at 100% 0%,
      rgba(196, 135, 38, 0.12),
      transparent 44%
    ),
    linear-gradient(100deg, var(--bnp-warning-soft), #fff 70%) !important;
}

.netpa-card--danger .netpa-card__header {
  background:
    radial-gradient(
      circle at 100% 0%,
      rgba(220, 53, 69, 0.14),
      transparent 44%
    ),
    linear-gradient(100deg, #f8d7da, #fff 70%) !important;
  border-bottom-color: rgba(220, 53, 69, 0.18) !important;
}

.netpa-card--featured .netpa-card__header {
  background:
    radial-gradient(
      circle at 100% 0%,
      rgba(5, 184, 200, 0.14),
      transparent 44%
    ),
    linear-gradient(
      100deg,
      rgba(5, 184, 200, 0.08),
      rgba(141, 88, 164, 0.05) 48%,
      #fff 78%
    ) !important;
}

.netpa-card__title {
  flex: 1 1 auto;
  min-width: 0;
  text-align: right;
}

.netpa-card__title >>> h6,
.netpa-card__title >>> .h6 {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 10px;
  width: 100%;
  margin: 0;
  color: var(--bnp-brand-navy) !important;
  font-family: inherit;
  font-size: 14px !important;
  font-weight: 800;
  line-height: 1.5;
  letter-spacing: -0.01em;
}

.netpa-card__title >>> .text-light,
.netpa-card__title >>> .text-white,
.netpa-card__title >>> .text-dark {
  color: var(--bnp-brand-navy) !important;
}

/* نشان آیکون عنوان — فقط آیکون اول عنوان، نه دکمه بازگشت */
.netpa-card__title >>> h6 > i.fas:not(.fa-arrow-left):not(.fa-times),
.netpa-card__title >>> h6 > i.fa:not(.fa-arrow-left):not(.fa-times),
.netpa-card__title >>> h6 > i.far:not(.fa-arrow-left):not(.fa-times),
.netpa-card__title >>> .h6 > i.fas:not(.fa-arrow-left):not(.fa-times),
.netpa-card__title >>> .h6 > i.fa:not(.fa-arrow-left):not(.fa-times),
.netpa-card__title >>> .h6 > i.far:not(.fa-arrow-left):not(.fa-times) {
  display: inline-grid;
  flex: 0 0 34px;
  width: 34px;
  height: 34px;
  margin-left: 0 !important;
  color: var(--bnp-brand-blue) !important;
  font-size: 14px !important;
  place-items: center;
  border-radius: 11px;
  background: var(--bnp-info-soft);
  box-shadow: inset 0 0 0 1px rgba(40, 125, 180, 0.1);
}

.netpa-card--warning .netpa-card__title >>> h6 > i.fas:not(.fa-arrow-left):not(.fa-times),
.netpa-card--warning .netpa-card__title >>> h6 > i.fa:not(.fa-arrow-left):not(.fa-times),
.netpa-card--warning .netpa-card__title >>> h6 > i.far:not(.fa-arrow-left):not(.fa-times) {
  color: var(--bnp-warning) !important;
  background: var(--bnp-warning-soft);
  box-shadow: inset 0 0 0 1px rgba(196, 135, 38, 0.14);
}

.netpa-card--danger .netpa-card__title >>> h6 > i.fas:not(.fa-arrow-left):not(.fa-times),
.netpa-card--danger .netpa-card__title >>> h6 > i.fa:not(.fa-arrow-left):not(.fa-times),
.netpa-card--danger .netpa-card__title >>> h6 > i.far:not(.fa-arrow-left):not(.fa-times) {
  color: #fff !important;
  background: #dc3545;
  box-shadow: none;
}

.netpa-card--featured .netpa-card__title >>> h6 > i.fas:not(.fa-arrow-left):not(.fa-times),
.netpa-card--featured .netpa-card__title >>> h6 > i.fa:not(.fa-arrow-left):not(.fa-times),
.netpa-card--featured .netpa-card__title >>> h6 > i.far:not(.fa-arrow-left):not(.fa-times) {
  color: #068997 !important;
  background: #e9f9fb;
  box-shadow: inset 0 0 0 1px rgba(5, 184, 200, 0.16);
}

/*
  دکمه بازگشت داخل هدر:
  با flex، float قدیمی کار نمی‌کند — به لبه چپ هل داده می‌شود
*/
.netpa-card__title >>> h6 > .float-left,
.netpa-card__title >>> .h6 > .float-left,
.netpa-card__title >>> h6 > i.fa-arrow-left.float-left,
.netpa-card__title >>> h6 > i.fas.fa-arrow-left {
  display: inline-flex !important;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  float: none !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  margin-left: 0 !important;
  margin-right: auto !important;
  margin-inline-start: auto !important;
  margin-inline-end: 0 !important;
  cursor: pointer;
}

.netpa-card__title >>> h6 > .float-left > i.fas,
.netpa-card__title >>> h6 > .float-left > i.fa,
.netpa-card__title >>> h6 > .float-left > i.far,
.netpa-card__title >>> .h6 > .float-left > i.fas,
.netpa-card__title >>> .h6 > .float-left > i.fa,
.netpa-card__title >>> h6 > i.fa-arrow-left,
.netpa-card__title >>> h6 > i.fas.fa-arrow-left,
.netpa-card__title >>> h6 > i.fa.fa-arrow-left {
  display: inline-grid !important;
  flex: 0 0 38px !important;
  width: 38px !important;
  height: 38px !important;
  float: none !important;
  margin: 0 !important;
  padding: 0 !important;
  color: var(--bnp-brand-navy) !important;
  font-size: 14px !important;
  line-height: 1 !important;
  place-items: center;
  cursor: pointer;
  border: 1px solid var(--bnp-border-default);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: none;
  transition:
    color var(--bnp-motion-fast) ease,
    border-color var(--bnp-motion-fast) ease,
    background var(--bnp-motion-fast) ease;
}

.netpa-card__title >>> h6 > .float-left > i:hover,
.netpa-card__title >>> .h6 > .float-left > i:hover,
.netpa-card__title >>> h6 > i.fa-arrow-left:hover,
.netpa-card__title >>> h6 > i.fas.fa-arrow-left:hover {
  color: var(--bnp-brand-purple) !important;
  border-color: rgba(141, 88, 164, 0.28);
  background: #f5eff8;
}

.netpa-card__toggle {
  display: grid;
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  margin: 0;
  padding: 0;
  color: var(--bnp-brand-navy);
  place-items: center;
  border: 1px solid var(--bnp-border-default);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.88);
  cursor: pointer;
  transition:
    color var(--bnp-motion-fast) ease,
    border-color var(--bnp-motion-fast) ease,
    background var(--bnp-motion-fast) ease;
}

.netpa-card__toggle:hover {
  color: var(--bnp-brand-purple);
  border-color: rgba(141, 88, 164, 0.28);
  background: #f5eff8;
}

.netpa-card__toggle:focus {
  outline: none;
}

.netpa-card__toggle:focus-visible {
  box-shadow: var(--bnp-focus-ring);
}

.netpa-card__toggle i {
  font-size: 13px;
  pointer-events: none;
}

.netpa-card__body {
  position: relative;
  z-index: 1;
  padding: 18px !important;
  color: var(--bnp-text-primary);
  background: var(--bnp-surface-card);
}

@media (max-width: 767px) {
  .netpa-card {
    border-radius: 16px !important;
  }

  .netpa-card:hover {
    transform: none;
  }

  .netpa-card__header {
    min-height: 56px;
    padding: 12px 14px !important;
  }

  .netpa-card__title >>> h6,
  .netpa-card__title >>> .h6 {
    font-size: 13px !important;
  }

  .netpa-card__body {
    padding: 14px !important;
  }
}

@media (prefers-reduced-motion: reduce) {
  .netpa-card,
  .netpa-card__toggle {
    transition: none;
  }

  .netpa-card:hover {
    transform: none;
  }
}
</style>
